import wallet from './wallet/routes';
import detail from './detail/routes';
import intro from './intro/routes';
import tryon from './tryon/routes';
import terms from './terms/routes';

export default [wallet, intro, detail, tryon, terms];
